// src/modules/loading/actions.js

import Vue from "vue";

export async function startLoading({ commit }) {
  try {
    commit("setLoading", true);
  } catch (e) {
    return e
  } finally {
  }
}
export async function stopLoading({ commit }) {
  try {
    commit("setLoading", false);
  } catch (e) {
    return e
  } finally {
  }
}